<template>
  <div v-if="loading" class="text-center mt-5 font-2xl text-muted">
    <i class="fal fa-spinner fa-spin" /> Change History Data Loading...
  </div>

  <div v-else class="animated fadeIn">
    <basic-heading title="Change History" class="mb-3">
      <template #right-content>
        <header-button-group :button_config="button_config">
        </header-button-group>
      </template>
    </basic-heading>

    <permission-alert-gate :permissions="'read customer'">
      <template #gated-content>
        <customer-card :customer="customer" />

        <div v-for="(item, index) in activity.models" :key="index">
          <div class="d-flex">
            <h3>
              {{ item.updated_at | moment('YYYY-MM-DD HH:mm:ss') }}
            </h3>
          </div>

          <b-card no-body class="bg-light">
            <div>
              <pre class="mb-0">{{ item.properties }}</pre>
            </div>
          </b-card>
        </div>
      </template>
    </permission-alert-gate>
  </div>
</template>

<script>
import { getCollection, getModel } from '@/shared/fetch-utils'
import ToastNotifications from '@/components/shared/mixins/ToastNotifications'
import PermissionAlertGate from "@/components/permission/PermissionAlertGate"
import CustomerCard from '@/components/crm/customer/CustomerCard'
import BasicHeading from '@/components/shared/BasicHeading'
import HeaderButtonGroup from '@/components/shared/headerbuttons/HeaderButtonGroup'

export default {
  name: "CustomerAuditTrailHistory",
  components: {
    PermissionAlertGate,
    CustomerCard,
    BasicHeading,
    HeaderButtonGroup
  },
  mixins: [ToastNotifications],
  data () {
    return {
      loading: true,
      customer: null,
      customer_id: this.$route.params.customer_id || null,
      activity: null
    };
  },
  computed: {
    button_config() {
      return {
        buttons: [
          {
            icon: "fa-arrow-left",
            linkto: `/customer/${this.customer_id}/audit-trail`,
            title: "Back to Audit Trail",
            variant: "success",
          },
          {
            icon: "fa-eye",
            linkto: `/customer/${this.customer_id}`,
            title: "View customer",
            variant: "info",
          }
        ]
      }
    },
  },
  async created () {
    this.loading = true

    this.customer = await getModel({
      model_type: 'customer',
      id: this.customer_id,
      message: this.$bvToast,
    })

    this.activity = await getCollection({
      collection_type: 'activity',
      message: this.$bvToast,
      filters: [
        {
          logic: "filterEquals",
          field: "subject_type",
          value: "Customer"
        },
        {
          logic: "filterEquals",
          field: "subject_id",
          value: this.customer_id
        },
      ],
      sort: [
        {
          logic: "sortAddDesc",
          field: "created_at",
        },
      ]
    })

    this.loading = false;
  },
}
</script>
